import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { validateForm } from '../../services/validate';
import { Post, PostAuthorized } from '../../services/http';
import CreditCardIcon from '../../images/ant-design_credit-card-filled.png';
import TermsPopup from '../../dialogs/terms-popup';

export const BanquestCreditCard = ({ doValidate, amount, invoiceNumber, paymentMode, reccuringMode, reccuringTerm, showTermsPopup }) => {
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const showSpinner = useStoreActions((action) => action.showSpinner);
    const hideSpinner = useStoreActions((action) => action.hideSpinner);

    const goToThankYouPage = (returnUrl) => {
        window.location.href = returnUrl;
    };

    const initFormMask = () => {
        let ccNumberInput = document.querySelector('.bnqst-number'),
            ccNumberPattern = /^\d{0,16}$/g,
            ccNumberSeparator = ' ',
            ccNumberInputOldValue,
            ccNumberInputOldCursor,
            ccExpiryInput = document.querySelector('.cc-expiry-input'),
            ccExpiryPattern = /^\d{0,4}$/g,
            ccExpirySeparator = '/',
            ccExpiryInputOldValue,
            ccExpiryInputOldCursor,

            ccCVCInput = document.querySelector('.cc-cvc-input'),
            ccCVCPattern = /^\d{0,3}$/g,

            mask = (value, limit, separator) => {
                let output = [];
                for (let i = 0; i < value.length; i++) {
                    if (i !== 0 && i % limit === 0) {
                        output.push(separator);
                    }

                    output.push(value[i]);
                }

                return output.join('');
            };
        const unmask = (value) => value.replace(/[^\d]/g, '');
        const checkSeparator = (position, interval) => Math.floor(position / (interval + 1));
        const ccNumberInputKeyDownHandler = (e) => {
            let el = e.target;
            ccNumberInputOldValue = el.value;
            ccNumberInputOldCursor = el.selectionEnd;
        };
        const highlightCC = (ccValue) => {
            let ccCardType = '',
                ccCardTypePatterns = {
                    amex: /^3/,
                    visa: /^4/,
                    mastercard: /^5/,
                    disc: /^6/,

                    genric: /(^1|^2|^7|^8|^9|^0)/,
                };

            for (const cardType in ccCardTypePatterns) {
                if (ccCardTypePatterns[cardType].test(ccValue)) {
                    ccCardType = cardType;
                    break;
                }
            }

            let activeCC = document.querySelector('.cc-types__img--active'),
                newActiveCC = document.querySelector(`.cc-types__img--${ccCardType}`);

            if (activeCC) activeCC.classList.remove('cc-types__img--active');
            if (newActiveCC) newActiveCC.classList.add('cc-types__img--active');
        };
        const ccNumberInputInputHandler = (e) => {
            let el = e.target,
                newValue = unmask(el.value),
                newCursorPosition;

            if (newValue.match(ccNumberPattern)) {
                newValue = mask(newValue, 4, ccNumberSeparator);

                newCursorPosition = ccNumberInputOldCursor - checkSeparator(ccNumberInputOldCursor, 4)
                    + checkSeparator(ccNumberInputOldCursor + (newValue.length - ccNumberInputOldValue.length), 4)
                    + (unmask(newValue).length - unmask(ccNumberInputOldValue).length);
                el.value = (newValue !== '') ? newValue : '';
            } else {
                el.value = ccNumberInputOldValue;
                newCursorPosition = ccNumberInputOldCursor;
            }

            el.setSelectionRange(newCursorPosition, newCursorPosition);

            // highlightCC(el.value);
        };

        const ccExpiryInputKeyDownHandler = (e) => {
            let el = e.target;
            ccExpiryInputOldValue = el.value;
            ccExpiryInputOldCursor = el.selectionEnd;
        };
        const ccExpiryInputInputHandler = (e) => {
            let el = e.target,
                newValue = el.value;

            newValue = unmask(newValue);
            if (newValue.match(ccExpiryPattern)) {
                newValue = mask(newValue, 2, ccExpirySeparator);
                el.value = newValue;
            } else {
                el.value = ccExpiryInputOldValue;
            }
        };

        ccNumberInput.addEventListener('keydown', ccNumberInputKeyDownHandler);
        ccNumberInput.addEventListener('input', ccNumberInputInputHandler);

        ccExpiryInput.addEventListener('keydown', ccExpiryInputKeyDownHandler);
        ccExpiryInput.addEventListener('input', ccExpiryInputInputHandler);
    };
    const scrollUp = () => {
        setTimeout(() => {
            window.scrollTo(0, 400);
        }, 1000);
    };
    const chargeCard = async () => {
        console.log('recurring details', reccuringTerm + ' ' + reccuringTerm);
        showSpinner();
        const validateCardDetails = validateForm(['bqst-card-number', 'bqst-expiry', 'bqst-cvc']);
        const validateDonorDetails = await doValidate();
        if (!validateCardDetails.result) {
            hideSpinner();
            openInfoPopup({ notice: validateCardDetails.notice, reload: false, btnName: 'OK', callback: scrollUp, isCallBack: true });
            return;
        }
        if (!validateDonorDetails.result) {
            hideSpinner();
            openInfoPopup({ notice: validateDonorDetails.notice, reload: false, btnName: 'OK', callback: scrollUp, isCallBack: true });
            return;
        }

        const card = document.getElementById('bqst-card-number').value;
        const expiry = document.getElementById('bqst-expiry').value;
        const cvc = document.getElementById('bqst-cvc').value;
        console.log('checking amount and parse amount see to values', amount + ' ' + parseInt(amount));
        const result = await Post('/api/donation/ChargeBanquest', {
            card,
            expiry,
            amount: parseInt(amount),
            cvc,
            invoiceNumber,
            reccuringMode,
            reccuringTerm,
        });
        if (result.result) {
            goToThankYouPage(config.frontDomain + 'thank-you/donation/' + invoiceNumber);
        } else {
            hideSpinner();
            openInfoPopup({ notice: result.message, reload: false, btnName: 'OK' });
        }
    };

    const createSubscription = async () => {
        showSpinner();
        console.log('try to validate!');
        const validateCardDetails = validateForm(['bqst-card-number', 'bqst-expiry', 'bqst-cvc', 'terms-checkbox']);
        const validateSignUpForm = await doValidate();
        if (!validateCardDetails.result) {
            hideSpinner();
            openInfoPopup({ notice: validateCardDetails.notice, reload: false, btnName: 'OK' });
            return;
        }
        if (!validateSignUpForm.result) {
            hideSpinner();
            openInfoPopup({ notice: validateSignUpForm.notice, reload: false, btnName: 'OK' });
            return;
        }
        const card = document.getElementById('bqst-card-number').value;
        const expiry = document.getElementById('bqst-expiry').value;
        const cvc = document.getElementById('bqst-cvc').value;

        console.log('checking amount and parse amount see to values', amount + ' ' + parseInt(amount));
        const result = await PostAuthorized('/api/donation/SubscribeBanquest', { card, expiry, amount: parseInt(amount), cvc, invoiceNumber });
        if (result.result) {
            goToThankYouPage(config.frontDomain + 'thank-you/subscriber-form/' + invoiceNumber);
        } else {
            hideSpinner();
            openInfoPopup({ notice: result.message, reload: false, btnName: 'OK' });
        }
    };

    React.useEffect(() => {
        setTimeout(() => {
            initFormMask();
        }, 1000);
    }, []);
    return (
        <>
            <div className="fieldset-body  _anim-items _fadeUp" data-animate-delay="02">
                <div className="form-grid">
                    <div className="form-grid__item col-12">
                        <div className="form-field form-insel" style={{ marginTop: 20 }}>
                            <p className="roboto f-normal f-24 weight-500 color-5">Card Number</p>
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={CreditCardIcon} alt="" />
                            <input onKeyUp={() => validateForm(['bqst-card-number'])} type="text" id="bqst-card-number" className="border-none input bnqst-number border-none input color-4 weight-400 f-16 roboto f-normal" placeholder="*********" />
                            </div>
                        </div>
                    </div>
                    <div className="form-grid__item col-3">
                        <div className="form-field form-insel">
                            <p className="roboto f-normal f-24 weight-500 color-5">Expiry (MM/Y)</p>
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                <input type="text" onKeyUp={() => validateForm(['bqst-expiry'])} id="bqst-expiry" className="border-none input color-4 weight-400 f-16 roboto f-normal cc-expiry-input" placeholder="MM / YY" />
                            </div>
                        </div>
                    </div>
                    <div className="form-grid__item col-3">
                        <div className="form-field form-insel">
                            <p className="roboto f-normal f-24 weight-500 color-5">Card Code</p>
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                <input type="text" onKeyUp={() => validateForm(['bqst-cvc'])} id="bqst-cvc" className="border-none input color-4 weight-400 f-16 roboto f-normal cc-cvc-input" placeholder="CVC" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {paymentMode === 'regular-donation' ? (
                <div className="form-button _anim-items _fadeUp" data-animate-delay="02">
                    <button onClick={chargeCard} className="form-btn form-btn--block form-btn--info" type="submit">Submit</button>
                </div>
            ) : ''}
            {paymentMode === 'campaign-subscription' ? (
                <>
                    <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                        {/* <div className="form-field">
                            <label className="flex">
                                <input style={{ width: '18px', height: '19px', background: '#E6E6E6', borderRadius: '2px' }} type="checkbox" id="terms-checkbox" onClick={() => validateForm(['terms-checkbox'])} />
                                <span className="checkbox__text weight-500 roboto f-normal f-16 color-5"> By clicking on the submit button below, you agree to <span class="link-like" onClick={showTermsPopup}>our terms</span> and to our $28 monthly fee.
                                    This fee will continue to be charged monthly until we receive an electronic notification
                                    that you want to cancel your subscription.
                                    Please allow up to one month from notice of cancelation.*</span>
                            </label>
                        </div> */}
                        <label className="checkbox" >
                                            <input style={{ width: '18px', height: '19px', background: '#E6E6E6', borderRadius: '2px' }} type="checkbox"  id="terms-checkbox" onClick={() => validateForm(['terms-checkbox'])} />
                                            <span className="checkbox__text">
                                                <span className="checkbox__text weight-500 roboto f-normal f-16 color-5"> By clicking on the submit button below, you agree to <span class="link-like" onClick={showTermsPopup}>our terms</span> and to our $28 monthly fee.
                                    This fee will continue to be charged monthly until we receive an electronic notification
                                    that you want to cancel your subscription.
                                    Please allow up to one month from notice of cancelation.*</span> 
                                            </span>
                                        </label>   
                    </div>
                    <div className="form-button _anim-items _fadeUp" data-animate-delay="02">
                        <div className="center-text">
                            <button className="rubik btn-red weight-500 f-22" style={{ width: 200, textTransform: 'uppercase' }} onClick={createSubscription} type="submit">Submit {'>'}</button>
                        </div>
                    </div>
                </>
            ) : ''}
        </>
    );
};
